import React from 'react';
import { ProductImage } from './ProductImage';

import './styles/product.scss';

export const ProductGrid = ({ heading, cta1, p1Name, p1Img, p1Price, p2Name, p2Img, p2Price, p3Name, p3Img, p3Price, p4Name, p4Img, p4Price }) =>
  <section className='column'>
    <div className='row spacer-bottom-md'>
      <h2>{heading}</h2>
    </div>
    <div className='row flex-space-between'>
      <div className='product__item'>
        <ProductImage image={p1Img} />
        <p>{p1Name}</p>
        <p>{p1Price}</p>
        <button aria-label={cta1}>{cta1}</button>
      </div>
      <div className='product__item'>
        <ProductImage image={p2Img} />
        <p>{p2Name}</p>
        <p>{p2Price}</p>
        <button aria-label={cta1}>{cta1}</button>
      </div>
      <div className='product__item'>
        <ProductImage image={p3Img} />
        <p>{p3Name}</p>
        <p>{p3Price}</p>
        <button aria-label={cta1}>{cta1}</button>
      </div>
      <div className='product__item'>
        <ProductImage image={p4Img} />
        <p>{p4Name}</p>
        <p>{p4Price}</p>
        <button aria-label={cta1}>{cta1}</button>
      </div>
    </div>
  </section>
